import { render } from "./FrontofficeKyc.vue?vue&type=template&id=daeb0536&scoped=true&ts=true"
import script from "./FrontofficeKyc.vue?vue&type=script&lang=ts"
export * from "./FrontofficeKyc.vue?vue&type=script&lang=ts"

import "./FrontofficeKyc.vue?vue&type=style&index=0&id=daeb0536&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daeb0536"]])

export default __exports__